<template>
  <div class="h-full">
    <slider
      animation="fade"
      :indicators="false"
      :interval="this.duration"
      :speed="500"
      height="100vh"
    >
      <template v-for="(item, i) in this.news">
        <slider-item
          :key="i"
          :style="i"
        >

          <div class="title font-bold text-indigo-600 pl-16 py-4" style="height: 10vh; max-height: 10vh; overflow: hidden; white-space: nowrap;">
            <div v-if="item.title.length <= 70" class="text-5xl truncate" v-html="item.title"></div>
            <div v-else-if="item.title.length > 70 && item.title.length < 100" class="text-4xl truncate" v-html="item.title"></div>
            <div v-else class="text-3xl py-3 truncate" v-html="item.title"></div>
          </div>

          <!-- <p>{{item.body.length}}</p> -->
          <div class="body flex w-full pl-8" style="height: 80vh; max-height: 80vh;">
            <!-- <span>{{item.title.length}}</span> -->
            <!-- <div v-if="item.img">
              <div v-if="item.img.src" class="flex">
                <div class="w-1/2">
                  <img class="h-128 object-cover pl-8" :src="item.img.src" :alt="item.img.alt">
                </div>
                <div class="w-1/2 text-3xl pl-8 pr-8" v-html="item.body">
                </div>
              </div>
            </div> -->
            <div class="newsbody flex w-full pl-8 pr-8 h-full leading-tighter text-4xl">

              <div v-html="limitStr(item.body, 600)"></div>
              <!-- <div v-else class="break-normal" v-html="item.body"></div> -->

              <!-- <div v-if="item.body.length <= 500" class="text-4xl pl-8 pr-8 h-full w-3/4" v-html="item.body"></div>
              <div v-else-if="item.body.length > 500 && item.body.length < 1000" class="text-3xl pl-8 pr-8  w-3/4" v-html="item.body"></div>
              <div v-else-if="item.body.length > 1000 && item.body.length < 2000" class="text-2xl pl-8 pr-8  w-3/4" v-html="item.body"></div>
              <div v-else-if="item.body.length > 2000 && item.body.length < 2500" class="text-xl pl-8 pr-8  w-3/4" v-html="item.body"></div>
              <div v-else class="w-full text-xs pl-8 pr-8" v-html="item.body"></div> -->
            </div>
          </div>

          <div class="footer flex flex-col pr-8 text-right" style="height: 10vh; max-height: 10vh;">
            <div class="date text-2xl text-gray-700">
              {{item.date | moment("D.M.YYYY")}}
            </div>

            <div class="source font-bold text-3xl">
              {{item.source}}
            </div>
          </div>

        </slider-item>
    </template>
    </slider>
  </div>
</template>

<script>
export default {
  name: 'News',
  props: ['news', 'duration'],
  methods: {
    limitStr (string, limit) {
      let str = string;

      if (typeof str === 'string' && str.length > limit) {
        str = str.slice(0, limit) + '...  <p class="text-indigo-600">Lue lisää intrasta</p>';
      }

      return str;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
p {
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
